// Module
var code = "<react-component name=\"DailyTakingsReport\"></react-component>\n";
// Exports
module.exports = code;